import React from 'react';

const FoulActionsSelections = ({
  handleFoulPart,
  setTeamFoulSections,
  teamFoulSections,
  actionPlayerId,
  starState,
  setStarState,
  star_logo
}) => {
  return (
    <div className="xxl:max-w-[570px] xxl:min-w-[570px] max-w-[244px] lg:max-w-[596px]  lg:min-w-[596px] min-w-[244px] w-full  p-2 lg:p-6 pr-0 lg:pr-0 flex flex-col gap-[10px] lg:gap-[23px]">
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] justify-end">
        <div
          onClick={() => [
            handleFoulPart("TF", actionPlayerId),
            setTeamFoulSections("TF"),
          ]}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              ${teamFoulSections == "TF"
              ? "bg-[#419066] text-light"
              : "text-[#C08C5E]"
            } cursor-pointer`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          TF
        </div>
        <div
          onClick={() => handleFoulPart("PF")}
          className={`max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center
              cursor-pointer ${teamFoulSections == "PF"
              ? "bg-[#419066] text-light"
              : "text-[#C08C5E]"
            }`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          PF
        </div>
      </div>
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] justify-end">
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
      </div>
      <div className="flex gap-[6px] md:gap-[10px] lg:gap-[23px] justify-end">
        <div className="max-w-[72px] md:max-w-[175px] relative  w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg text-[#D54043] leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center">
          <div
            className="max-w-[59.28px] lg:max-w-[140px] w-full lg:h-[140px] h-[59.28px] rounded-full text-[#D54043] leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            {starState && (
              <div
                onClick={() => setStarState(!starState)}
                className="absolute max-w-[53.35px] lg:max-w-[126px] cursor-pointer w-full lg:h-[126px] h-[53.35px]  bg-gray-300 bg-opacity-80 rounded-full"
              ></div>
            )}
            <img
              onClick={() => setStarState(!starState)}
              className="max-w-[53.35px] lg:max-w-[126px] cursor-pointer  w-full lg:h-[126px] h-[53.35px] rounded-full "
              src={star_logo}
              alt=""
              srcSet=""
            />
          </div>
        </div>
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
        <div className="max-w-[72px] lg:max-w-[175px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[80px] flex justify-center items-center font-bebas text-[32px] lg:text-[80px] text-center"></div>
      </div>
    </div>
  );
};

export default FoulActionsSelections;